import React from "react";
import { shallow } from "zustand/shallow";

import type { ShareClassData, ShareClassMeta } from "@hsl/fund-explorer/types";

import useExplorerStore from "../store/store";

function useShareClassData(shareClassArr: string[]) {
    const { getDataById, shareClasses } = useExplorerStore(
        ({ getDataById, refinedData: { shareClasses } }) => ({
            getDataById,
            shareClasses,
        }),
        shallow,
    );
    const shareClassData = React.useMemo(
        () =>
            shareClassArr
                .filter((shareClass) => shareClasses.includes(shareClass))
                .map((id) => getDataById(id)) as (ShareClassData & {
                data: ShareClassMeta;
            })[],
        [shareClassArr, shareClasses],
    );
    return shareClassData;
}

export default useShareClassData;
